import type { useI18n } from "@nelurio/i18n";

type TFunc = ReturnType<typeof useI18n>["t"];

export function shortId(t: TFunc, id: string | null | undefined): string {
  if (!id) return t("admin.common.missing");
  return id.length > 10 ? `${id.slice(0, 8)}\u2026` : id;
}

export function isOverdue(dueAt: string, status: string): boolean {
  if (status === "completed") return false;
  const due = new Date(dueAt).getTime();
  return Number.isFinite(due) && due < Date.now();
}
